
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M507.594 489.46c-3.932 4.469-9.784 7.025-16.051 7.025H20.461c-6.271 0-12.121-2.558-16.045-7.025-3.396-3.859-4.918-8.787-4.27-13.836.452-3.52 1.108-7.906 1.108-7.906 12.291-76.34 58.183-141.587 121.985-180.022l-.002-.002.161-.094a256.421 256.421 0 0113.144-7.401 169.003 169.003 0 0012.208 11.047c-.175.086-.346.182-.521.271 28.916 24.344 66.242 39.018 106.999 39.018 41.018 0 78.562-14.863 107.556-39.488-.172-.086-.34-.178-.512-.262a169.416 169.416 0 0012.153-11.104c.104.053.205.108.309.161.108-.11.221-.221.327-.332a256.07 256.07 0 0113.04 7.234c-.114.125-.233.245-.349.37 64.304 38.357 110.592 103.879 122.944 180.605l.037.174c.406 2.564.781 5.142 1.113 7.732.661 5.048-.845 9.954-4.252 13.835zm-25.347-30.389c-10.932-63.719-74.05-134.731-104.817-146.159-28.186 25.501-68.675 44.182-123.604 43.275-49.733-.82-91.782-15.275-120.406-42.999C92.686 336.1 41.098 396.667 30.221 460.071c0 0-.729 5.468-.774 5.413-1.363 6.566 3.206 6.062 3.206 6.062s17.738-.049 29.861-.049c21.039 0 59.585-.727 80.623-.727 73.343 0 146.706.727 220.05.727h89.191c9.463 0 26.269-.011 26.269-.011s4.649-.209 4.513-4.476c-.233-2.976-.913-7.939-.913-7.939zM255.489 308.215c-80.696 0-146.351-65.653-146.351-146.35s65.654-146.35 146.351-146.35c80.693 0 146.349 65.653 146.349 146.351 0 80.696-65.655 146.349-146.349 146.349zm0-263.077c-64.368 0-116.729 52.361-116.729 116.728 0 64.367 52.36 116.728 116.729 116.728 64.364 0 116.726-52.359 116.726-116.728 0-64.367-52.361-116.728-116.726-116.728z"}})])
          )
        }
      }
    